// src/pages/LoadingPage.js
import React from 'react';

export default function LoadingPage({ message = 'Loading…' }) {
  return (
    <div className="page-center" style={{ flexDirection: 'column', gap: '1rem' }}>
      <div className="spinner" />
      <p style={{ color: 'var(--gray-600)', fontSize: '.9rem' }}>{message}</p>
    </div>
  );
}
